<template>
	<el-container class="home_container">
		<div class="box">
			<h3 class="box_title">电力平台</h3>
			<label class="box_title2">管理端</label>
			<div style="position: relative;">
				<el-input type="text" class="username" autocomplete="off" placeholder="请输入账号" v-model="userName" @change="usernameBlur()" @focus="focusClick()" @blur="blurClick()" prefix-icon="iconfont icon-yonghu iconClass"></el-input>
				<ul class="borderStyle" v-show="bankNameInputShow">
					<li @mousedown="mouseClick(index)" v-for="(item,index) in list">{{item.username}}</li>
				</ul>
			</div>
			<el-input type="password" class="password" placeholder="密码加密" v-model="passWordMd5" style="display: none;" prefix-icon="iconfont icon-suoding iconClass"></el-input>
			<el-input type="password" class="password" placeholder="请输入密码" v-model="passWord" @change="passChange()" prefix-icon="iconfont icon-suoding iconClass"></el-input>
			<el-form>
				<el-form-item class="btn">
					<!--@click.prevent是防止input点击？-->
					<button type="primary" @click.prevent="loginClick()" class="loginButton">登录</button>
				</el-form-item>
			</el-form>
		</div>
		<div class="beian">
			<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备17006853号</a>
		</div>
	</el-container>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../static/js/headers.js'
	import md5 from '../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		data() {
			return {
				bankNameInputShow: false, //搜索列表
				userName: '', //用户名
				passWord: '', //密码
				passWordMd5: '', //加密密码
				userList: [], //历史用户列表
				usernameValue: '',
				list: [],
				notDo: false, //不执行开关
			};
		},
		computed: {
			...mapGetters(['http'])
		},
		mounted() {
			this.loginBefore(); //用户列表
			/*用户记录的处理*/
			if(window.localStorage.userArr) { //判断是否存在
				this.list = JSON.parse(window.localStorage.userArr);
			} else {
				this.list = []; //创建一个新数组
			}
		},
		methods: {
			//用户记录的处理
			focusClick() {
				if(this.list.length > 0) {
					this.bankNameInputShow = true
				}
			},
			blurClick() {
				this.bankNameInputShow = false
			},
			mouseClick(index) {
				this.list.forEach((item, i) => {
					if(index == i) {
						this.userName = item.username
						this.usernameBlur();
					}
				})
			},
			//登陆跳转
			loginBefore() {
				var id = window.sessionStorage.getItem('id')
				if(id) {
					this.$router.push({
						path: '/home',
						name: 'Home'
					})
				}
			},
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			//用户名光标离开触发
			usernameBlur() {
				this.passChange();
				var params = {
					username: this.userName
				}
				let config = headers.headers('getByUsername')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/b_manager/getByUsername', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(!res.data.id) {
						this.$message('该用户名不存在！');
						this.userName = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//登陆的点击
			loginClick() {
				if(!this.userName && !this.passWord) {
					this.$message('请输入用户名和密码！');
					this.userName = ''
					this.passWord = ''
					this.notDo = true
					return
				} else if(!this.userName) {
					this.$message('请输入用户名！');
					this.userName = ''
					this.notDo = true
					return
				} else if(!this.passWord) {
					this.$message('请输入密码！');
					this.passWord = ''
					this.notDo = true
					return
				} else {
					this.notDo = false
				}
				this.openFullScreen();
				var params = {
					username: this.userName,
					password: this.passWordMd5
				}
				//console.log(params)
				let config = headers.headers('getByUsernameAndPassword')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					axios.get(this.http + '/zkep2/b_manager/getByUsernameAndPassword', {
						params,
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						this.loadingAdd.close();
						if(res.data.id) {
							window.sessionStorage.setItem('id', res.data.id)
							window.sessionStorage.setItem('b_id', res.data.b_id)
							window.sessionStorage.setItem('manager', res.data.username)
							if(window.sessionStorage.getItem('referrer')) {
								this.$router.push(window.sessionStorage.getItem('referrer'))
								var index = window.location.href.lastIndexOf("#");
								var url = window.location.href.substring(window.location.href.length, index + 1)
								if(url == '/customerOverview/customerOverview') { //客户总览
									this.activeName = 'first'
									window.sessionStorage.setItem('activeName', 'first')
								} else if(url == '/customer/customer' || url.indexOf('/customer/customerC') != -1 || url.indexOf('/customer/equipment') != -1 || url.indexOf('/customer/gateway') != -1 || url.indexOf('/customer/list') != -1) { //客户管理
									this.activeName = 'second'
									window.sessionStorage.setItem('activeName', 'second')
								} else if(url == '/operations/operations') { //运维管理
									this.activeName = 'third'
									window.sessionStorage.setItem('activeName', 'third')
								} else if(url == '/manager/manager') { //用户管理
									this.activeName = 'fourth'
									window.sessionStorage.setItem('activeName', 'fourth')
								}
							} else {
								this.$router.push({
									path: '/home',
									name: 'Home'
								})
							}
							/*用户记录的处理*/
							for(var i = 0; i < this.list.length; i++) {
								//判断是否有相同账号
								if(res.data.username == this.list[i].username) {
									return;
								}
							}
							//创建对象
							var obj = {
								username: res.data.username
							}
							this.list.push(obj);
							window.localStorage.userArr = JSON.stringify(this.list);
						} else {
							this.$message('用户名或密码错误，请重新登录！')
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//密码改变
			passChange() {
				this.passWordMd5 = md5(this.passWord + this.userName + 'eq2') //md5格式
			},
		}
	}
</script>

<style>
	.home_container {
		width: 100%;
		height: 100%;
		background-color: #CCD0D9;
		/*background: url(../../assets/background.png) no-repeat;*/
		position: relative;
	}
	
	.box {
		width: 27%;
		min-width: 360px;
		height: 470px;
		background-color: #fff;
		margin: 0 auto;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		box-shadow: 0px 0 5px #ccc;
		/*左、上、右*/
	}
	
	.box_title {
		color: #3962D6;
		font-weight: 600;
		font-size: 28px;
		margin-top: 60px;
		margin-bottom: 12px;
	}
	
	.box_title2 {
		display: block;
		color: #3962D6;
		font-weight: 400;
		font-size: 22px;
		margin-bottom: 50px;
	}
	
	.iconClass {
		color: #BDBDBD;
		font-size: 16px;
	}
	
	.username,
	.password {
		position: relative;
		font-size: 14px;
		outline: none;
		width: 280px;
		border-radius: 0;
		box-shadow: none;
		outline: none;
	}
	
	.el-input__inner:focus {
		/*outline: none;*/
		border: 1px solid #BDBDBD;
		/*输入框获取焦点时给边框加颜色*/
	}
	
	.username .el-input__inner {
		border-bottom-left-radius: 0!important;
		border-bottom-right-radius: 0!important;
		outline: none;
	}
	
	.password .el-input__inner {
		border-top-left-radius: 0!important;
		border-top: 0;
		border-top-right-radius: 0!important;
	}
	
	.loginButton {
		margin-top: 10%;
		width: 270px;
		height: 38px;
		background-color: #3962D6;
		border: none;
		border-radius: 4px;
		color: #fff;
		outline: none;
	}
	
	input::-webkit-input-placeholder {
		color: #BDBDBD;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
	/*登陆历史记录*/
	
	.borderStyle {
		text-align: left;
		position: absolute;
		top: 100%;
		left: 16.3%;
		background: #fff;
		width: 279px;
		z-index: 100;
		border-radius: 5px;
		overflow: auto;
		box-shadow: 1px 2px 4px #ccc;
	}
	
	ul {
		padding: 0;
		margin: 0;
		list-style: none;
	}
	
	.borderStyle li {
		padding: 11px 0;
		margin: 10px 0;
		text-indent: 10px;
	}
	
	.borderStyle li:hover {
		background: #C8C9CC;
	}
	
	.beian {
		position: absolute;
		bottom: 20px;
		left: 45%;
	}
	
	.beian a {
		cursor: pointer;
		color: #333;
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue